module.exports = __webpack_public_path__ + "img/hsa.e96dda22.jpg";